import {REJECT_SCHOOL} from "./../../routes";
import customAxios from "../../customAxios";

const rejectSchool = async (userId: string) => {
  try {
    return (await customAxios.put(REJECT_SCHOOL + `/${userId}`)).data;
  } catch (error: unknown) {
    console.error({REJECT_SCHOOL: error});
    return false;
  }
};

export default rejectSchool;
